module.exports = __webpack_public_path__ + "img/title.393dfa57.png";